import type { Product } from '../generated/graphql'
import { isProductForSale } from './is-product-for-sale'

export function filterOutProductsNotForSale(products: Product[]) {
  return products.filter((product) => isProductForSale(product))
}
